<template>
  <div class="error">
    <div class="container-fluid">
      <div class="row">
        <div class="col col-md-10 offset-md-1">
          <div class="faq">
            <h1 class="faq-headline">{{ $t('pages.faq.headline') }}</h1>
            <p>{{ $t('pages.faq.copy') }}</p>
            <ul class="faq-list">
              <li class="faq-list__item" :class="{ 'faq-list__item--active': questions[index].active }"
                  v-for="(question, index) of questions" :key="index">
                <h2 class="faq-question" @click="toggleAnswer(index)" v-html="question.question"></h2>
                <p class="faq-answer" v-html="question.answer"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FrequentlyAskedQuestions',
  data() {
    return {
      activeObjectNumber: null,
      questions: this.$t('pages.faq.questions'),
    }
  },
  created() {
    this.handleQueryParameter()
  },
  methods: {
    handleQueryParameter() {
      /* istanbul ignore else */
      if (this.$route.query.q) {
        /* if questions has given query, otherwise remove query from url */
        this.questions[this.$route.query.q]
          ? this.toggleAnswer(this.$route.query.q)
          : this.$router.push({ name: this.$route.name })
      }
    },

    toggleAnswer(index) {
      /* close last active question if it's not the same as clicked */
      /* istanbul ignore else */
      if (this.activeObjectNumber !== null && this.activeObjectNumber !== index) {
        const question = { ...this.questions[this.activeObjectNumber], active: false }
        this.$set(this.questions, this.activeObjectNumber, question)
      }

      /* toggle active status of clicked question */
      const question = { ...this.questions[index], active: !this.questions[index].active }
      this.$set(this.questions, index, question)

      /* if new question is active set index and update url */
      if (question.active) {
        this.activeObjectNumber = index
        this.$router.push({ name: this.$route.name, query: { q: this.activeObjectNumber } })
      } else {
        this.activeObjectNumber = null
        this.$router.push({ name: this.$route.name })
      }

      /* scroll active question into view */
      /* istanbul ignore next */
      if (question.active) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$el.querySelector('.faq-list__item--active').scrollIntoView({ behavior: 'smooth' })
          }, 1)
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.faq {
  background-color: white;
  padding: 0 20px 20px;
  margin: 0;

  @include media-breakpoint-up(md) {
    margin: 50px 0;
    padding: 20px;
  }
}

.faq-headline {
  @include font-format(2rem, 2.25rem);

  color: var(--primary-color);
  margin: 0;
  padding: 20px 0;
  text-transform: uppercase;
}

.faq-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.faq-list__item {
  border-top: 1px dotted #dce7eb;
  margin: 0;
  padding: 20px 0 0;
}

.faq-question {
  @include font-format(1.125rem, 1.625rem);

  cursor: pointer;
  display: block;
  margin: 0;
  padding-right: 30px;
  position: relative;

  &::after,
  &::before {
    background-color: var(--primary-color);
    content: '';
    height: 9px;
    position: absolute;
    right: 5px;
    top: 50%;
    width: 3px;
    transition: all 0.25s ease-in-out;
  }

  &::before {
    transform: translate(2px, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-2px, -50%) rotate(-45deg);
  }
}

.faq-list__item--active .faq-question {
  margin: 0 0 20px;

  &::after {
    transform: translate(2px, 0) rotate(-45deg);
  }

  &::before {
    transform: translate(-2px, 0) rotate(45deg);
  }
}

.faq-answer {
  @include font-format(1.063rem, 1.625rem);

  height: 0;
  margin: 0 30px 20px 0;
  opacity: 0;
  overflow: hidden;
  transform: translate(0, 50%);
  transition: all 0.25s ease-in-out;
}

.faq-list__item--active .faq-answer {
  height: auto;
  opacity: 0.7;
  transform: translate(0, 0);
  transition: all 0.25s ease-in-out;
}
</style>
